module.exports = __webpack_public_path__ + "static/media/seeds-of-life.4609a2d0.jpg";